import axios from 'axios'
import { parseExistingUserInfo } from '../../utils/parseExistingUserInfo'
import {
  signupOrigin,
} from '../../utils/setLocalStorage'

// initial state
const registrationState = {
  individual: {
    isSubmitted: false,
    isSuccess: true,
    emailSubmitted: null,
    errorMessage: null,
  },
  signupOrigin: null,
  searchingUser: false,
  existingUserInfo: null,
  isExistingUserSearchDone: false,
}

// getters
const getters = {
  signupOrigin(state) {
    return state.signupOrigin
  },
  parsedExistingUser(state) {
    if (!state.existingUserInfo) {
      return
    }
    return parseExistingUserInfo(state.existingUserInfo)
  },
}

// actions
const actions = {
  async POST_VALID_EMAIL({ rootState }, email) {
    try {
      const data = await axios.post(`${rootState.api}/emails/exist`, {
        email,
      })
      return data
    } catch (error) {
      console.error(error)
    }
  },
  POST_REGISTER_LIGHT({ commit, rootState }, userInfo) {
    axios
      .post(`${rootState.api}/register`, {
        light: parseInt(userInfo.light, 10),
        type: userInfo.type,
        email: userInfo.email,
        civility: parseInt(userInfo.gender, 10),
        first_name: userInfo.firstName,
        last_name: userInfo.lastName,
        tel: userInfo.phone,
        password: userInfo.password,
        optin_email: userInfo.optin_email,
        optin_sms: userInfo.optin_sms,
        ...(userInfo.signup_origin && { signup_origin: userInfo.signup_origin }),
      })
      .then((res) => commit('SET_SUCCESS_MESSAGE', res.data.data))
      .catch((error) => commit('SET_ERROR_MESSAGE', error))
  },
  POST_REGISTER_INDIVIDUAL({ commit, rootState }, userInfo) {
    axios
      .post(`${rootState.api}/register`, {
        light: parseInt(userInfo.light, 10),
        type: userInfo.type,
        email: userInfo.email,
        civility: parseInt(userInfo.civility, 10),
        first_name: userInfo.first_name,
        last_name: userInfo.last_name,
        birthday: userInfo.birthday.custom,
        birthplace: userInfo.birthplace,
        address: userInfo.address,
        city: userInfo.city,
        postal_code: userInfo.postal_code,
        country_id: userInfo.country,
        tel: userInfo.tel,
        licence_number: userInfo.licence_number,
        licence_date: userInfo.licence_date.custom,
        licence_place: userInfo.licence_place,
        password: userInfo.password,
        optin_email: userInfo.optin_email,
        optin_sms: userInfo.optin_sms,
        ...(userInfo.signup_origin && { signup_origin: userInfo.signup_origin }),
      })
      .then((res) => {
        commit('SET_SUCCESS_MESSAGE', res.data.data)
      })
      .catch((error) => commit('SET_ERROR_MESSAGE', error))
  },
  POST_REGISTER_PRO({ commit, rootState }, userInfo) {
    axios
      .post(`${rootState.api}/register`, {
        light: parseInt(userInfo.light, 10),
        type: userInfo.type,
        email: userInfo.email,
        company_name: userInfo.company,
        company_siret: userInfo.vat,
        address: userInfo.address,
        city: userInfo.city,
        tel: userInfo.tel,
        postal_code: userInfo.postal_code,
        country_id: userInfo.country,
        password: userInfo.password,
        civility: parseInt(userInfo.civility, 10),
        first_name: userInfo.first_name,
        last_name: userInfo.last_name,
        birthday: userInfo.birthday.custom,
        birthplace: userInfo.birthplace,
        licence_number: userInfo.licence_number,
        licence_date: userInfo.licence_date.custom,
        licence_place: userInfo.licence_place,
        optin_email: userInfo.optin_email,
        optin_sms: userInfo.optin_sms,
        ...(userInfo.signup_origin && { signup_origin: userInfo.signup_origin }),
      })
      .then((res) => commit('SET_SUCCESS_MESSAGE', res.data.data))
      .catch((error) => commit('SET_ERROR_MESSAGE', error))
  },
  FIND_EXISTING_USER({ commit, rootState }, {
    /* eslint-disable camelcase */
    type,
    account_number,
    business,
    zipcode,
    email,
    first_name,
    last_name,
    birthday,
    /* eslint-enable camelcase */
  }) {
    commit('SET_SEARCHING_USER', true)
    axios
      .post(`${rootState.api}/rrs/user`, {
        type,
        account_number,
        business,
        zipcode,
        email,
        first_name,
        last_name,
        birthday,
      })
      .then((res) => commit('SET_EXISTING_USER_INFO', res?.data?.data))
      .finally(() => {
        commit('SET_IS_EXISTING_USER_SEARCH_DONE')
        commit('SET_SEARCHING_USER', false)
      })
  },
}

// mutations
const mutations = {
  RESET_MESSAGE(state) {
    state.individual.isSubmitted = false
    state.individual.isSuccess = false
    state.individual.emailSubmitted = null
  },
  SET_SUCCESS_MESSAGE(state, res) {
    state.individual.isSubmitted = true
    state.individual.isSuccess = true
    state.individual.emailSubmitted = res.email
  },
  SET_ERROR_MESSAGE(state, error) {
    state.individual.isSubmitted = true
    state.individual.isSuccess = false
    state.individual.errorMessage = error
  },
  SET_SIGN_UP_ORIGIN(state, origin) {
    state.signupOrigin = origin
    signupOrigin(origin)
  },
  SET_SEARCHING_USER(state, searchingUser) {
    state.searchingUser = searchingUser
  },
  SET_EXISTING_USER_INFO(state, existingUserInfo) {
    state.existingUserInfo = existingUserInfo.userRrs
  },
  SET_IS_EXISTING_USER_SEARCH_DONE(state) {
    state.isExistingUserSearchDone = true
  },
}

export default {
  namespaced: true,
  state: registrationState,
  getters,
  actions,
  mutations,
}
